import React from 'react'
import ExcelCard from './ExcelCard'
import { useStateContext } from '../contexts/ContextProvider'
import Typography from '@mui/material/Typography';
import styled from '@emotion/styled'

const Container = styled.div`
    border: 2px solid #444;
    border-radius: 20px;
    padding: 8px;
    margin: 20px;
    height: 90vh;
    overflow-y: auto;
`

function ExcelList() {
    const { excelList } = useStateContext();


    return (
        <Container>
            <Typography variant="h5" component="div" style={{ textAlign: 'center'}}>
                My List
            </Typography>
            {excelList.map((item, index) => (
                <ExcelCard key={index} name={item.name} url={item.url} date={item.date} />
            ))}
        </Container>
    )
}

export default ExcelList
